"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayChecklistChangeMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const tags_1 = require("../../atoms/tags");
const react_1 = require("react");
const icons_1 = require("../../atoms/icons");
const renderWeekDays = (days, startDay, getDateFns) => {
    return days.map((day, idx) => {
        const offset = idx + startDay;
        let dayIdx = offset;
        if (offset > 6) {
            dayIdx = offset - 7;
        }
        if (offset < 0) {
            dayIdx = 7 + offset;
        }
        return ((0, jsx_runtime_1.jsx)(Day, { onClick: getDateFns && getDateFns[idx], isClickable: !!getDateFns, children: days[dayIdx] }, day));
    });
};
const Day = (0, styled_components_1.default)(typography_1.P) `
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "unset")};
`;
exports.default = ({ title, startDay, showChecklistChange, isAverage = false, onHeaderClick = () => { }, onLogbookClick = () => { }, getDateFns = [() => { }] }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const days = t("time.shortcutsOfDays", { returnObjects: true });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showChecklistChange && ((0, jsx_runtime_1.jsx)(exports.DisplayChecklistChangeMessage, { onLogbookClick: onLogbookClick }, void 0)), (0, jsx_runtime_1.jsxs)(Wrapper, { isHeaderClickable: !!onHeaderClick, children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { onClick: onHeaderClick, "data-cy": "progress-overview-header", children: title }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [isAverage && (0, jsx_runtime_1.jsx)("p", { children: t("recovery.average") }, "average"), renderWeekDays(days, startDay, getDateFns)] }, void 0)] }, void 0)] }, void 0));
};
const DisplayChecklistChangeMessage = ({ onLogbookClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isVisible, setIsVisible] = (0, react_1.useState)(true);
    const checklistChangeMessage = t("recovery.checklistChanges", {
        returnObjects: true
    })
        .split(" ")
        .map((word, index, elements) => {
        if (word === "logboek" || word === "logbook") {
            return ((0, jsx_runtime_1.jsx)("a", { style: {
                    verticalAlign: "baseline",
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                    marginRight: "0.25rem"
                }, onClick: (e) => {
                    e.preventDefault();
                    onLogbookClick();
                }, children: word }, void 0));
        }
        return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [word, index !== elements.length - 1 && " ", " "] }, index));
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isVisible ? ((0, jsx_runtime_1.jsx)(Wrapper, { isHeaderClickable: false, children: (0, jsx_runtime_1.jsxs)(tags_1.Tag, { variant: "yellow", style: {
                    margin: 0,
                    height: "auto",
                    whiteSpace: "normal"
                }, children: [checklistChangeMessage.map((el, index) => {
                        return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: typeof el === "string" ? el + " " : el }, index));
                    }), (0, jsx_runtime_1.jsx)(icons_1.Icon, { onClick: () => setIsVisible(false), shape: "rectangle", icon: ["fal", "times"], color: "grey" }, void 0)] }, void 0) }, void 0)) : null }, void 0));
};
exports.DisplayChecklistChangeMessage = DisplayChecklistChangeMessage;
const Wrapper = styled_components_1.default.div `
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: flex;
  flex: 1;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  h2,
  p {
    margin-bottom: 0;
    line-height: 1.5rem;
  }

  h2 {
    flex: 3;
    ${({ isHeaderClickable }) => isHeaderClickable ? `cursor: pointer` : ""};
  }

  & > div {
    display: flex;
    flex: 8;
    width: 100%;
  }
  p {
    text-align: center;
    width: 100%;
  }
`;
//# sourceMappingURL=TableHeader.js.map